import { render } from "./ClaimActionButtons.vue?vue&type=template&id=702c28bf&scoped=true"
import script from "./ClaimActionButtons.vue?vue&type=script&lang=js"
export * from "./ClaimActionButtons.vue?vue&type=script&lang=js"

import "./ClaimActionButtons.vue?vue&type=style&index=0&id=702c28bf&scoped=true&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-702c28bf"]])

export default __exports__